import $ from 'jquery';

// jQuery Definitionen
window.jQuery = $;
window.$ = $;

// Scripts asynchron laden
(function ($) {
    $.extend({
        loadScript: function (source, callback, cache) {
            var c = (typeof cache == 'undefined' ? true : cache);
            (function (d, t) {
                var g = d.createElement(t),
                    s = d.getElementsByTagName(t)[0];
                g.src = source + (c == false ? '?_=' + new Date().getTime() : '');
                g.onload = function () {
                    callback();
                };
                s.parentNode.insertBefore(g, s);
            }(document, 'script'));
        }
    });
})($);